;
define("quantity_pricing.tpl", function(){});

